export default {
  data: () => ({
    translations: {
      image: {
        el: 'Εικόνα',
        en: 'Image',
        it: 'Immagine',
      },
      promoType: {
        el: 'Τύπος Κουπονιού',
        en: 'Coupon Type',
        it: 'Tipo di promo',
      },
      promoName: {
        el: 'Όνομα Κουπονιού',
        en: 'Coupon Name',
        it: 'Nome di promo',
      },
      code: {
        el: 'Κωδικός',
        en: 'Code',
        it: 'Codice',
      },
      available: {
        el: 'Διαθέσιμα',
        en: 'Available',
        it: 'Disponibile',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      totalRedeemed: {
        el: 'Εξαργυρωμένα',
        en: 'Total Redeemed',
        it: 'Totale riscattato',
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Data',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      view: {
        el: 'Προβολή',
        en: 'View',
        it: 'Vedi',
      },
      modalTitle: {
        el: 'Εξαργυρωμένα Κουπόνια και Κωδικοί Κουπονιών',
        en: 'Redeemed Coupon and Voucher Codes',
        it: 'Buoni riscattati e codici promozionali',
      },
      mobile: {
        el: 'Κινητό',
        en: 'Mobile',
        it: 'Cellulare',
      },
      voucherOrCouponCode: {
        el: 'Κωδικός Κουπονιού ή Επιταγής',
        en: 'Voucher or Coupon Code',
        it: 'Codice voucher o coupon',
      },
      redemptionTimestamp: {
        el: 'Χρονοσφραγίδα Εξαργύρωσης',
        en: 'Redemption Timestamp',
        it: 'Timestamp di riscatto',
      },
      value: {
        el: 'Αξία',
        en: 'Value',
        it: 'Valore',
      },
      timestamp: {
        el: 'Χρονοσφραγίδα',
        en: 'Timestamp',
        it: 'Marca temporale',
      },
      voucherCode: {
        el: 'Κωδικός κουπονιού',
        en: 'Voucher code',
        it: 'Codice Promozionale',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
    },
  }),
};
